import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateHeaderFooterComponent } from './template-header-footer/template-header-footer.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/Shared/material.module';

@NgModule({
  declarations: [TemplateHeaderFooterComponent],
  exports: [TemplateHeaderFooterComponent, DragDropModule],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    // RouterModule.forChild(routes),
    MatDialogModule,
    DragDropModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class TemplateHeaderFooterModule {}
